<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="show"
    @close="onChange"
    class="add-type-modal"
    title
    width="480px"
  >
    <div slot="title" style="font-weight:bold">{{ title }}</div>

    <el-form :model="params" :rules="rules" class="type-body" label-width="100px" ref="formType">
      <el-form-item :label="label" prop="value">
        <el-input :placeholder="`${holderText}`" type="text" v-model.trim="params.value" maxlength="20"></el-input>
      </el-form-item>
    </el-form>

    <div class="dialog-footer" slot="footer" style="text-align:center">
      <el-button size="small" @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button size="small" :loading="loading" @click="onSave" type="primary">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { postUpdateDicByCode } from '@/server/common'
export default {
  name: 'type-modal',
  computed: {
    title() {
      const str = this.$t('system::common::modal_title_add')
      return (
        str +
        ({
          afterTypes: this.$t('after-sales::after-sale-list::new_after_sale_type'),
          refundTypes: this.$t('after-sales::after-sale-list::new_refund'),
          afterSources: this.$t('after-sales::after-sale-list::new_source')
        }[this.drawRow.type] || '')
      )
    },
    label() {
      return (
        {
          afterTypes: this.$t('after-sales::after-sale-list::new_after_sale_type'),
          refundTypes: this.$t('after-sales::after-sale-list::new_refund'),
          afterSources: this.$t('after-sales::after-sale-list::new_source')
        }[this.drawRow.type] || ''
      )
    },
    holderText() {
      const str = this.$t('system::common::input_holder')
      return (
        str +
        ({
          afterTypes: this.$t('after-sales::after-sale-list::new_after_sale_type'),
          refundTypes: this.$t('after-sales::after-sale-list::new_refund'),
          afterSources: this.$t('after-sales::after-sale-list::new_source')
        }[this.drawRow.type] || '')
      )
    }
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible(bool) {
      this.show = bool
      const data = this.drawRow
      this.params = {
        value: ''
      }
      this.$nextTick(() => this.$refs.formType.clearValidate())
    },
    drawRow: {
      handler: function(data) {},
      deep: true
    }
  },
  data() {
    return {
      loading: false,
      rules: {
        value: [
          {
            required: true,
            message: `${this.$t('system::common::input_holder')}${{
              afterTypes: this.$t('after-sales::after-sale-list::new_after_sale_type'),
              refundTypes: this.$t('after-sales::after-sale-list::new_refund'),
              afterSources: this.$t('after-sales::after-sale-list::new_source')
            }[this.drawRow.type] || ''}`,
            trigger: 'blur'
          }
        ]
      },
      show: false,
      params: {}
    }
  },
  mounted() {},
  methods: {
    onChange() {
      this.$emit('change', false)
    },
    onSave() {
      this.$refs['formType'].validate(async valid => {
        if (valid) {
          this.loading = true
          let params = {
            ...this.params
          }
          const type = {
            afterTypes: 1,
            refundTypes: 2,
            afterSources: 3
          }[this.drawRow.type]

          const { data } = await postUpdateDicByCode({
            items: [
              {
                name: this.params.value,
                sequence: 0,
                status: 1,
                type: type
              }
            ],
            type
          })

          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('save', this.drawRow.type)
            this.$emit('change', false)
          }
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.add-type-modal {
  ::v-deep {
    .el-dialog__body {
      padding: 40px 52px 8px;
    }
  }

  .type-body {
    .input-item {
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
</style>
